import { Shield, Database, Activity, RefreshCw, Eye } from "lucide-react";

const metrics = [
  { icon: Activity, label: "Uptime", value: "Monitored", color: "text-emerald-400" },
  { icon: Database, label: "Backups", value: "Daily", color: "text-emerald-400" },
  { icon: Shield, label: "Malware", value: "Checked", color: "text-emerald-400" },
  { icon: RefreshCw, label: "Updates", value: "Managed", color: "text-sky-400" },
];

export default function HeroDashboard() {
  return (
    <div data-testid="hero-dashboard" className="relative">
      <div className="absolute -inset-4 bg-gradient-to-br from-[#0F2942]/5 to-[#1A4A40]/5 rounded-3xl blur-2xl" />
      <div className="relative bg-[#0A1118] rounded-2xl p-5 sm:p-6 shadow-2xl border border-[#133E59]/30">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-pulse-soft" />
            <span className="text-white/50 text-[11px] tracking-[0.15em] uppercase font-mono">
              Live Monitoring
            </span>
          </div>
          <span className="text-white/60 text-[11px] font-mono">ordell.ro</span>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {metrics.map((m) => (
            <div
              key={m.label}
              className="bg-white/[0.04] rounded-xl p-3.5 border border-white/[0.06]"
            >
              <div className="flex items-center gap-2 mb-2">
                <m.icon className="w-3.5 h-3.5 text-white/60" />
                <span className="text-[11px] text-white/60 uppercase tracking-wider font-mono">
                  {m.label}
                </span>
              </div>
              <span className={`text-lg font-semibold font-mono ${m.color}`}>
                {m.value}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-4 bg-white/[0.04] rounded-xl p-3.5 border border-white/[0.06]">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <Eye className="w-3.5 h-3.5 text-white/60" />
              <span className="text-[11px] text-white/60 uppercase tracking-wider font-mono">
                Monitoring
              </span>
            </div>
            <span className="text-emerald-400 text-[11px] font-mono font-medium">ACTIVE</span>
          </div>
          <div className="flex gap-1 items-end h-8">
            {[40, 65, 45, 80, 55, 70, 60, 85, 50, 75, 68, 90, 72, 88, 65, 78].map((h, i) => (
              <div
                key={i}
                className="flex-1 bg-emerald-400/20 rounded-sm min-w-[3px]"
                style={{ height: `${h}%` }}
              >
                <div
                  className="w-full bg-emerald-400/60 rounded-sm"
                  style={{ height: `${Math.min(100, h + 15)}%` }}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="mt-3 pt-3 border-t border-white/[0.06] flex items-center justify-between">
          <span className="text-[10px] text-white/50 font-mono">Active Monitoring</span>
          <div className="flex gap-1">
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-400/50" />
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-400/25" />
          </div>
        </div>
      </div>
    </div>
  );
}
